const NAVIGATION_STATES = {
  WELCOME: "WELCOME",
  OPT_IN: "OPT_IN",
  OPT_OUT: "OPT_OUT",
  FILLED_OUT: "FILLED_OUT",
  SUBMITTED: "SUBMITTED",
  ERROR: "ERROR"
};

export { NAVIGATION_STATES };
